import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_CALENDAR_AUTOCOMPLETE } from 'src/api/trips';
import { useMemo } from 'react';
import { setNotification } from 'src/redux/Notifications/sliceNotifications';

export interface IShortTrip {
  id: number;
  name: string;
  partner_id: number;
  partner_name: string;
  comission: string;
}

interface ICalendarAutocomplete {
  v1_general_trips: IShortTrip[];
}

export const useCalendarAutocomplete = () => {
  const dispatch = useDispatch();
  const { data, loading } = useQuery<ICalendarAutocomplete>(
    GET_CALENDAR_AUTOCOMPLETE,
    {
      onError: (error) => {
        dispatch(
          setNotification({
            type: 'error',
            message: error.message,
            duaration: 10000,
          })
        );
      },
      fetchPolicy: 'cache-first',
      pollInterval: 1800000,
    }
  );

  const { partnerList, tripList } = useMemo(() => {
    if (!data?.v1_general_trips)
      return {
        partnerList: [],
        tripList: [],
      };
    const partnerList: { id: number; name: string }[] = [];

    const tripList = (data?.v1_general_trips || []).map((i) => {
      if (!partnerList.find((p) => p.id === i.partner_id)) {
        partnerList.push({
          id: i.partner_id,
          name: i.partner_name,
        });
      }
      return {
        ...i,
        name: `#${i.id} — ${i.name}`,
      };
    });
    return {
      partnerList: partnerList.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      }),
      tripList,
    };
  }, [data]);

  return {
    partnerList,
    tripList,
    loading,
  };
};
